import styles from '@casops/side-panels/manage-geofence/components/form/GeofenceForm.module.scss';
import useGeofenceFormTabs from '@casops/side-panels/manage-geofence/components/form/useGeofenceFormTabs';
import { defaultGeofenceFormValues } from '@casops/side-panels/manage-geofence/components/form/GeofenceForm';
import Tabs from '@cas/components/tabs/tabs/Tabs';
import { GeofenceFormModel, GeofenceModel } from '@casops/store/apis/geofencesApi';
import { DrawerForm } from '@dmc/ui';
import { DefaultValues, useForm } from 'react-hook-form';
import { ReactElement, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '@casops/store/hooks';
import { closeSidePanel } from '@casops/store/slices/globalSlice';
import { VdsButton } from '@volt/volt-extended-components-react';

type DataModel = GeofenceModel;
type FormModel = GeofenceFormModel;

interface GeofenceFormReadonlyProps {
  item?: DataModel;
}

export function GeofenceFormReadonly({ item }: GeofenceFormReadonlyProps): ReactElement {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const initialValues = useMemo<DefaultValues<FormModel>>(() => {
    return { ...defaultGeofenceFormValues, ...item };
  }, [item]);

  const { control, resetField } = useForm<FormModel>({ defaultValues: initialValues });

  const { activeView, ...tabsProps } = useGeofenceFormTabs({
    control,
    resetField,
    isReadonly: true,
  });

  const onClose = useCallback(() => {
    dispatch(closeSidePanel());
  }, [dispatch]);

  return (
    <DrawerForm
      footer={
        <VdsButton variant="ghost" size="medium" isFullWidth onClick={onClose}>
          {t('Close')}
        </VdsButton>
      }
    >
      <>
        <Tabs {...tabsProps} hasBorder />
        <div className={styles.fields}>{activeView}</div>
      </>
    </DrawerForm>
  );
}

export default GeofenceFormReadonly;
